module.exports = __webpack_public_path__ + "img/football.66365aea.svg";